import { StateCreator } from "zustand";

import { TableSelectionState } from "../types";

const makeTableSelectionSlice =
  <T extends TableSelectionState>(): StateCreator<
    T,
    [["zustand/immer", never]],
    [["zustand/devtools", never]],
    TableSelectionState
  > =>
  (set) => ({
    selected: new Set(),
    disabledIds: new Set(),
    allItemsCount: 0,
    loading: false,

    addSelected: (ids: string[]) =>
      set((state) => {
        const next = new Set(state.selected);
        ids.forEach((id) => {
          if (!state.disabledIds.has(id)) {
            next.add(id);
          }
        });
        state.selected = next;
      }),
    removeSelected: (ids: string[]) =>
      set((state) => {
        const next = new Set(state.selected);
        ids.forEach((id) => {
          next.delete(id);
        });
        state.selected = next;
      }),
    replaceSelected: (ids: string[]) =>
      set((state) => {
        state.selected = new Set(ids);
        state.refetchSelected = undefined;
      }),
    toggle: (id: string) =>
      set((state) => {
        if (state.disabledIds.has(id)) return;

        const next = new Set(state.selected);
        if (next.has(id)) {
          next.delete(id);
        } else {
          next.add(id);
        }
        state.selected = next;
      }),
    setDisabledIds: (ids: string[]) =>
      set((state) => {
        state.disabledIds = new Set(ids);
        if (ids.length === 0) {
          return;
        }

        const next = new Set(state.selected);
        ids.forEach((id) => {
          next.delete(id);
        });
        state.selected = next;
      }),
    setAllItemsCount: (count: number) =>
      set((state) => {
        state.allItemsCount = count;
      }),
    clearSelected: () =>
      set((state) => {
        state.selected = new Set();
        state.refetchSelected = undefined;
      }),
    setLoading: (loading: boolean) =>
      set((state) => {
        state.loading = loading;
      }),

    refetchSelected: undefined,
    setRefetchSelected: (refetch: () => Promise<unknown>) =>
      set((state) => {
        state.refetchSelected = refetch;
      }),
  });

export default makeTableSelectionSlice;
